// ============================================================================
// HOOK: usePortalNotifications
// Contagens de pendências do portal do cliente.
// Compartilhado por NotificationBell (mobile) e sidebar desktop (PortalLayout).
// ============================================================================

import { useEffect, useState } from 'react';
import { FIREBASE_CONFIG } from '../config/Config';
import {
  watchPendingDocuments,
  watchPendingTasks,
  watchPendingInvoices,
} from '../services/PortalNotificationsRepository.js';
import { usePortalContext } from '../context/PortalContext';

const appId = FIREBASE_CONFIG.projectId;

export function usePortalNotifications() {
  const { crmClient } = usePortalContext();
  const clientId = String(crmClient?.id || '').trim();

  const [docs,     setDocs]     = useState([]);
  const [tasks,    setTasks]    = useState([]);
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    if (!clientId || !appId) { setDocs([]); return; }
    const unsub = watchPendingDocuments(appId, clientId, (data) => setDocs(data));
    return () => unsub();
  }, [clientId]);

  useEffect(() => {
    if (!clientId || !appId) { setTasks([]); return; }
    const unsub = watchPendingTasks(appId, clientId, (data) => setTasks(data));
    return () => unsub();
  }, [clientId]);

  useEffect(() => {
    if (!clientId || !appId) { setInvoices([]); return; }
    const unsub = watchPendingInvoices(appId, clientId, (data) => setInvoices(data));
    return () => unsub();
  }, [clientId]);

  return {
    docs,
    tasks,
    invoices,
    total:        docs.length + tasks.length + invoices.length,
    docCount:     docs.length,
    taskCount:    tasks.length,
    invoiceCount: invoices.length,
  };
}
